// @flow
import styled from 'styled-components';
import { Link } from 'react-router';

export const SideMenuLink = styled(Link)`
  && { // Fok BStrap
    display: block;
    padding: 0.5rem 2rem 0.5rem 0.65rem;
    min-width: 11rem;
    text-align: left;
    border-left: 0.35rem solid transparent;
    color: ${({theme}) => theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT};
    font-size: 1.167rem;
  }
  
  &&:hover { // Fok BStrap
   color: ${({theme}) => theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT_HOVER};
   background: ${({theme}) => theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.BACKGROUND_HOVER};
   border-color:  ${({theme}) => theme.ThemeColors.SIDE_NAV_BAR_HOVER.hex};
   
   a {
      color: ${({theme}) => theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT};
   }
  }
`;

export default SideMenuLink;


// WEBPACK FOOTER //
// ./src/app/components/browse/SideMenuLink.js